import { setTerms } from './helpers';

export const setBuildingGatesType = setTerms('building_gates_type');
